import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="main-footer bt-1 text-center mt-auto" style={{marginTop:'auto'}}>
        &copy; <script>document.write(new Date().getFullYear())</script> <a href="#">Happie Marketing</a>. All Rights Reserved.&nbsp;&nbsp;
        <Link to={"/terms"} target='_blank'>Terms & Conditions</Link> ● <Link to={"/privacypolicy"} target='_blank'>Privacy Policy</Link>
      </footer>
  )
}

export default Footer